// extracted by mini-css-extract-plugin
export default {"file":"style_file__XZtSn","noData":"style_noData__FksIF"};